import { Link } from '@tanstack/react-router';
import { FiHelpCircle, FiHome, FiArrowLeft } from 'react-icons/fi';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-surface px-4">
      <div className="w-full max-w-md text-center">
        <div className="mb-6 flex justify-center">
          <div className="rounded-full bg-accent-soft p-6">
            <FiHelpCircle className="h-16 w-16 text-accent" aria-hidden="true" />
          </div>
        </div>

        <h1 className="mb-3 text-4xl font-bold text-content">404</h1>
        <h2 className="mb-4 text-xl font-semibold text-content">Page Not Found</h2>

        <p className="mb-8 text-content-muted">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </p>

        <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
          <Link
            to="/overview"
            className="inline-flex items-center justify-center gap-2 rounded-control border border-accent bg-accent px-4 py-2 text-sm font-medium text-accent-content transition-colors hover:opacity-90"
          >
            <FiHome className="h-4 w-4" aria-hidden="true" />
            Go to Dashboard
          </Link>

          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center gap-2 rounded-control border border-border bg-surface px-4 py-2 text-sm font-medium text-content transition-colors hover:bg-surface-raised"
          >
            <FiArrowLeft className="h-4 w-4" aria-hidden="true" />
            Go Back
          </button>
        </div>

        <div className="mt-8 rounded-surface border border-border bg-surface-sunken p-4 text-left">
          <p className="mb-2 text-sm font-medium text-content">Need help?</p>
          <ul className="space-y-1 text-sm text-content-muted">
            <li>• Check the URL for typos</li>
            <li>• Make sure you have the right permissions</li>
            <li>• Contact your workspace admin if the issue persists</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
